/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductDto } from '../../models/backend-advanced-product-dto';

export interface SalesAdvancedProductsList$Params {
  /**
   * A search term.
   */
  search?: string;
  variant?: number;
}

export function salesAdvancedProductsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesAdvancedProductsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendAdvancedProductDto>>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductsList.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('variant', params.variant, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendAdvancedProductDto>>;
    }),
  );
}

salesAdvancedProductsList.PATH = '/api/sales/advanced-products/';
